import { HRN_LEVEL_COLORS } from '@/constants/hrn.constants.js'

export default function useHrn() {
  const getHrnLevelColor = (level) => {
    return HRN_LEVEL_COLORS[level] || ''
  }

  const getHrnLevel = (hrn_result) => {
    if (!hrn_result) return null

    if (hrn_result < 1) {
      return 1
    } else if (hrn_result < 6) {
      return 2
    } else if (hrn_result < 11) {
      return 3
    } else if (hrn_result < 51) {
      return 4
    } else if (hrn_result < 101) {
      return 5
    } else if (hrn_result < 501) {
      return 6
    } else if (hrn_result < 1001) {
      return 7
    } else if (hrn_result >= 1001) {
      return 8
    }
  }

  return {
    getHrnLevelColor,
    getHrnLevel,
  }
}
